function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#68D4F8"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CEF2FF",
  d: "M48 26v-3a2 2 0 00-2-2H19a2 2 0 00-2 2v19c0 1.1.9 2 2 2h3V29c0-1.66 1.33-3 3-3h23z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M55 32v-3a1 1 0 00-1-1H25a1 1 0 00-1 1v3h31zm0 5v13a1 1 0 01-1 1H25a1 1 0 01-1-1V37h31z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 2,
  x: 42,
  y: 47,
  fill: "#CEF2FF",
  rx: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 2,
  x: 48,
  y: 47,
  fill: "#CEF2FF",
  rx: 0.5
});

function SvgInternationalSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MiA3MiI+PGNpcmNsZSBjeD0iMzYiIGN5PSIzNiIgcj0iMzYiIGZpbGw9IiM2OEQ0RjgiLz48cGF0aCBmaWxsPSIjQ0VGMkZGIiBkPSJNNDggMjZ2LTNhMiAyIDAgMCAwLTItMkgxOWEyIDIgMCAwIDAtMiAydjE5YzAgMS4xLjkgMiAyIDJoM1YyOWMwLTEuNjYgMS4zMy0zIDMtM2gyM3oiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNNTUgMzJ2LTNhMSAxIDAgMCAwLTEtMUgyNWExIDEgMCAwIDAtMSAxdjNoMzF6bTAgNXYxM2ExIDEgMCAwIDEtMSAxSDI1YTEgMSAwIDAgMS0xLTFWMzdoMzF6Ii8+PHJlY3Qgd2lkdGg9IjUiIGhlaWdodD0iMiIgeD0iNDIiIHk9IjQ3IiBmaWxsPSIjQ0VGMkZGIiByeD0iLjUiLz48cmVjdCB3aWR0aD0iNSIgaGVpZ2h0PSIyIiB4PSI0OCIgeT0iNDciIGZpbGw9IiNDRUYyRkYiIHJ4PSIuNSIvPjwvc3ZnPgo=";
export { SvgInternationalSupport as ReactComponent };